/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FileClassification = {
  readonly id?: number;
  filename: string;
  file_type: FileClassification.file_type;
  /**
   * Secondary classification of the document (e.g., CAP_TABLE, BALANCE_SHEET)
   */
  document_reference_secondary_classification?: FileClassification.document_reference_secondary_classification | null;
  readonly secondary_classification_display?: string;
  readonly uploaded_date?: string;
  uploaded_by?: number | null;
};
export namespace FileClassification {
  export enum file_type {
    CSV = 'csv',
    DOC = 'doc',
    DOCX = 'docx',
    DOCM = 'docm',
    GIF = 'gif',
    JPEG = 'jpeg',
    JPG = 'jpg',
    KEY = 'key',
    MD = 'md',
    NUMBERS = 'numbers',
    PAGES = 'pages',
    PDF = 'pdf',
    PNG = 'png',
    PPT = 'ppt',
    PPTX = 'pptx',
    PPSM = 'ppsm',
    PPTM = 'pptm',
    RTF = 'rtf',
    TXT = 'txt',
    XLS = 'xls',
    XLSX = 'xlsx',
    XLSM = 'xlsm',
    XLSB = 'xlsb',
    ZIP = 'zip',
  }
  /**
   * Secondary classification of the document (e.g., CAP_TABLE, BALANCE_SHEET)
   */
  export enum document_reference_secondary_classification {
    CAP_TABLE = 'CAP_TABLE',
    BALANCE_SHEET = 'BALANCE_SHEET',
    INCOME_STATEMENT = 'INCOME_STATEMENT',
    CASH_FLOW_STATEMENT = 'CASH_FLOW_STATEMENT',
    OTHER = 'OTHER',
  }
}
